import React, { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { CircularProgress, Divider } from '@material-ui/core'
import ServiceAssigner from './ServiceAssigner'
import ServiceEstimator from './ServiceEstimator'

const EstimateTab = ({ packageId, url, onUpdate }) => {
  const [items, setItems] = useState([])
  const [aggregatedServices, setAggregatedServices] = useState([])
  const [services, setServices] = useState([])
  const [templates, setTemplates] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchItems = useCallback(() => {
    return axios.get(`${url}/api/bid-estimation/bid-packages/${packageId}/items`)
      .then(res => setItems(res.data || []))
  }, [packageId, url])

  const fetchAggregated = useCallback(() => {
    return axios.get(`${url}/api/bid-estimation/bid-packages/${packageId}/services`)
      .then(res => setAggregatedServices(res.data || []))
  }, [packageId, url])

  const fetchServices = useCallback(() => {
    return axios.get(`${url}/api/bid-estimation/services`)
      .then(res => setServices(res.data || []))
  }, [url])

  const fetchTemplates = useCallback(() => {
    return axios.get(`${url}/api/bid-estimation/service-templates`)
      .then(res => setTemplates(res.data || []))
  }, [url])

  useEffect(() => {
    setLoading(true)
    Promise.all([fetchItems(), fetchAggregated(), fetchServices(), fetchTemplates()])
      .then(() => setLoading(false))
      .catch(() => setLoading(false))
  }, [packageId])

  const handleAssign = async (itemIds, serviceId, serviceName, serviceCategory) => {
    try {
      await axios.post(`${url}/api/bid-estimation/bid-items/assign-service`, {
        itemIds, serviceId, serviceName, serviceCategory
      })
      await fetchAggregated()
      if (onUpdate) onUpdate()
    } catch (e) {
      console.error('Assign failed:', e)
      alert('Assign failed: ' + (e.response?.data?.error || e.message))
    }
  }

  const handleRemove = async (itemIds, serviceId) => {
    try {
      await axios.post(`${url}/api/bid-estimation/bid-items/remove-service`, {
        itemIds, serviceId
      })
      await fetchAggregated()
      if (onUpdate) onUpdate()
    } catch (e) {
      console.error('Remove failed:', e)
    }
  }

  const handleTemplateCreated = () => {
    fetchTemplates()
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
        <CircularProgress />
      </div>
    )
  }

  return (
    <div>
      <ServiceAssigner
        items={items}
        aggregatedServices={aggregatedServices}
        services={services}
        onAssign={handleAssign}
        onRemove={handleRemove}
      />

      <Divider style={{ margin: '16px 0', borderColor: '#1976d2', borderWidth: 1 }} />

      <ServiceEstimator
        aggregatedServices={aggregatedServices}
        templates={templates}
        url={url}
        onTemplateCreated={handleTemplateCreated}
      />
    </div>
  )
}

export default EstimateTab
